import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import admin from "../../assets/admin.png";

const FollowSuggestions = ({ followStatus, onFollowToggle, currentUserId }) => {
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const fetchProfiles = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/user/profile/all-profiles/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
           "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      const data = await res.json();
      if (res.ok) {
        setProfiles(data.results || []);
      } else {
        console.error("Failed to fetch profiles");
      }
    } catch (err) {
      console.error("Error fetching profiles:", err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfiles();
  }, []);

  const handleProfileClick = (profile) => {
    if (String(profile.id) === String(currentUserId)) {
      navigate("/profile-view", {
        state: { isOwnProfile: true, profileData: profile },
      });
    } else {
      navigate(`/user-profile/${profile.id}`, {
        state: { isOwnProfile: false, profileData: profile },
      });
    }
  };

  return (
  //   <div className="follow-suggestions">
  //     <h2>Find People to Follow</h2>
  //     <p>Start following others to see their updates on your feed.</p>

  //     {isLoading ? (
  //       <p>Loading...</p>
  //     ) : (
  //       <div className="profile-list">
  //         {profiles?.length > 0 ? (
  //           profiles.map((profile) => {
  //             if (String(profile.id) === String(currentUserId)) return null;

  //             const isFollowing = followStatus[String(profile.id)];

  //             return (
  //               <div
  //                 key={profile.id}
  //                 className="profile-card"
  //                 onClick={() => handleProfileClick(profile)}
  //                 style={{ cursor: "pointer" }}
  //               >
  //              <div className="pro_box_img">   <img
  //                   src={profile.profile_picture || admin}
  //                   alt={profile.name}
  //                 /></div>
  //                 <div className="card_desc">
  //                   <h4>{profile.name}</h4>
  //                   <button
  // className={`follow-bttn ${isFollowing ? "following" : ""}`}
  //                     onClick={(e) => {
  //                       e.stopPropagation();
  //                       onFollowToggle(profile.id);
  //                     }}
  //                   >
  //                     {isFollowing ? "Following" : "Follow"}
  //                   </button>
  //                 </div>
  //               </div>
  //             );
  //           })
  //         ) : (
  //           <p>No profiles found.</p>
  //         )}
  //       </div>
  //     )}
  //   </div>
  // max-w-6xl 
  <div className="w-full mx-auto py-12 px-4 bg-white rounded-xl text-center">
  <div className="mb-10">
    <h2 className="text-3xl font-semibold text-gray-900 mb-3">Find People to Follow</h2>
    <p className="text-lg text-gray-600">
      Start following others to see their updates on your feed.
    </p>
  </div>

  {isLoading ? (
    <div className="flex justify-center py-16">
      <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
    </div>
  ) : (
    <div className="flex flex-wrap justify-center gap-6">
      {profiles?.length > 0 ? (
        profiles.map((profile) => {
          if (String(profile.id) === String(currentUserId)) return null;

          const isFollowing = followStatus[String(profile.id)];

          return (
            <div
              key={profile.id}
              className="flex flex-col items-center w-64 p-6 bg-white border border-gray-200 rounded-xl cursor-pointer hover:shadow-lg hover:border-gray-300 transition-all"
              onClick={() => handleProfileClick(profile)}
            >
              <div className="relative mb-4">
                <img
                  src={profile.profile_picture || admin}
                  alt={profile.name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-md"
                />
                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
              
              <h4 className="text-base font-semibold text-gray-900 mb-2 text-center truncate w-full">
                {profile.name}
              </h4>
              
              <button
                className={`px-5 py-2 rounded-xl text-sm font-medium transition-colors ${
                  isFollowing
                    ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    : "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  onFollowToggle(profile.id);
                }}
              >
                {isFollowing ? (
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    Following
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Follow
                  </div>
                )}
              </button>
            </div>
          );
        })
      ) : (
        <div className="w-full py-16">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
          </div>
          <p className="text-gray-600">No profiles found.</p>
        </div>
      )}
    </div>
  )}
</div>
  );
};

export default FollowSuggestions;
